import { useEffect, useState } from "react";
import { Box, Typography, Paper, useMediaQuery, Tooltip } from "@mui/material";
import ButtonComp from "../../../../components/Button";
import activePolicy from "../../../../assets/images/activePolicy.svg";
import inactivePolicy from "../../../../assets/images/inactivePolicy.svg";
import activeClaim from "../../../../assets/images/activeClaim.svg";
import inactiveClaim from "../../../../assets/images/inactiveClaim.svg";
import activeDetails from "../../../../assets/images/activeDetails.svg";
import inactiveDetails from "../../../../assets/images/inactiveDetails.svg";
import activeBanking from "../../../../assets/images/activeBanking.svg";
import inactiveBanking from "../../../../assets/images/inactiveBanking.svg";
import activeClaimInfo from "../../../../assets/images/activeClaimInfo.svg";
import inactiveClaimInfo from "../../../../assets/images/inactiveClaimInfo.svg";
import activeDocument from "../../../../assets/images/activeDocument.svg";
import inactiveDocument from "../../../../assets/images/inactiveDocument.svg";
import activeReview from "../../../../assets/images/activeReview.svg";
import inactiveReview from "../../../../assets/images/inactiveReview.svg";
import ClaimTabs from "../common/ClaimTabs";
import PolicyInfoForm from "../informations/death-claim/components/PolicyInfoForm";
import ClaimantPersonalInfoForm from "../informations/death-claim/components/ClaimantPersonalInfoForm";
import DetailsOfDeceasedForm from "../informations/death-claim/components/DetailsOfDeceasedForm";
import BankingInfoForm from "../informations/death-claim/components/BankingInfoForm";
import ClaimsBenefitScheduleForm from "../informations/death-claim/components/ClaimsBenefitScheduleForm";
import CustomDropdown from "../../../../components/CustomDropdown";
import AssignmentPopup from "../../../../components/AssignmentPopup";
import { useVerifiedStore } from "../../../../store/useVerifiedStore";
import VerifiedPopup from "../../../../components/VerifiedPopup";
import { useUserStore } from "../../../../store/useUserStore";
import SubmitPopup from "../../../../components/SubmitPopup";
import {
  assignMe,
  changeClaimAssignment,
  claimSubmit,
  closeClaim,
  getClaimDetails,
  getUserRoles,
  approveBenefitOverride,
  rejectBenefitOverride,
  getBenefitOverrideHistory,
  getBenefitInceptionContext,
  submitBenefitOverride,
  uploadDocs,
} from "../../../../services/dashboard";
import { useAuthStore } from "../../../../store/useAuthStore";
import { useToast } from "../../../../hooks/useToast";
import Loader from "../../../../components/Loader";
import RejectedPopup from "../../../../components/RejectedPopup";
import FinanceSubmitPopup from "../../../../components/FinanceSubmitPopup";
import CloseClaimPopup from "../../../../components/CloseClaimPopup";
import { useClaimTypeStore } from "../../../../store/useClaimTypeStore";
import SupportingDocumentsSection from "./death-claim/components/SupportingDocumentsSection";
import DocumentVerificationForm from "./tenpercent-claim/components/DocumentVerificationForm";
import ClaimsScheduleForm from "./tenpercent-claim/components/ClaimsScheduleForm";
import PersonalInformationForm from "../informations/tenpercent-claim/components/PersonalInformationForm";
import BankingForm from "../informations/tenpercent-claim/components/BankingForm";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { useVerifyCheckboxStore } from "../../../../store/useVerifyCheckboxStore";
import { useAssignedClaimStore } from "../../../../store/useAssignedClaimStore";
import ButtonUnderwriter from "../../../underwriter/components/ButtonUnderwriter";
import ClaimApprovePopup from "../../../underwriter/components/ClaimApprovePopup";
import RejectDialogueBox from "../../../underwriter/components/RejectDialogueBox";
import checkIcon from "../../../../assets/images/checkIcon.svg";
import rejectIcon from "../../../../assets/images/rejectIcon.svg";
import ClaimSubmitResponse from "../../../underwriter/components/ClaimSubmitResponse";
import HistoryIcon from "@mui/icons-material/History";
import { useTheme } from "@mui/material/styles";
import UnderwirterReview from "./death-claim/components/UnderwirterReview";
import Button from "../../../../components/Button";
import { useClaimFormStore } from "../../../../store/useClaimFormStore";
import { toast } from "react-toastify";
import { useClaimDetailsStore } from "../../../../store/useClaimDetailsStore";

type PersonalInfoProp = {
  onHistoryClick: () => void;
  resetToClaimList: () => void;
  claimData: any;
  assignmentDetails: string;
  claimStatus: string;
  isEditable?: boolean;
  handleUpdate?: () => void;
  onEditClick: () => void;
  setClaimDetails?: any;
  handleVerifiedCheck?: (checked: boolean) => void;
  claimDetails: any;
  handleFileUpload: any;
  onDocumentFileChange: any;
  isFilterClicked: boolean;
  isClaimSearched: boolean;
  reassigned:any;
  claimBenefitData:any;
  onBenefitTypeChange: (type: string) => void;
};

const isStatusInRoleQueue = (role?: string, status?: string) => {
  const statusesByRole: Record<string, string[]> = {
    consultant: ["DRAFT"],
    claim_administrator: ["VETTED"],
    claim_manager: ["NEW"],
    underwriter: ["REVIEWED", "DECLINED", "REJECTED"],
    finance: ["APPROVED"],
  };
  return Boolean(status && statusesByRole[String(role).toLowerCase()]?.includes(status));
};

const PersonalInfo = (props: PersonalInfoProp) => {
  const {
    onHistoryClick,
    resetToClaimList,
    claimData,
    assignmentDetails,
    claimStatus,
    isEditable,
    handleUpdate,
    onEditClick,
    setClaimDetails,
    claimDetails,
    handleFileUpload,
    onDocumentFileChange,
    isFilterClicked,
    isClaimSearched,
    reassigned,
    claimBenefitData,
    onBenefitTypeChange
  } = props;

  const [formattedDocuments, setFormattedDocuments] = useState<any[]>([]);
  const [isDocsInitialized, setIsDocsInitialized] = useState(false);
  const isOrangeCampaign =  claimData.data.is_orange_campaign;
  const isClaimSubmissionWindowExpired = Boolean(
    claimBenefitData?.isClaimSubmissionWindowExpired ??
      claimBenefitData?.is_claim_submission_window_expired ??
      claimData.data?.isClaimSubmissionWindowExpired ??
      claimData.data?.is_claim_submission_window_expired,
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeTab, setActiveTab] = useState(0);
  const [value, setValue] = useState("");
  const [showAssignment, setShowAssignment] = useState(false);
  const [showManagerSubmitPopup, setShowManagerSubmitPopup] = useState(false);
  const [showFinanceSubmitPopup, setShowFinanceSubmitPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [popupLabel, setPopupLabel] = useState("");
  const [policyComment, setPolicyComment] = useState("");
  const [personalInfoComment, setPersonalInfoComment] = useState("");
  const [claimantComment, setClaimantComment] = useState("");
  const [documentComment, setDocumentComment] = useState("");
  const [deceasedComment, setDeceasedComment] = useState("");
  const [bankingComment, setBankingComment] = useState("");
  const [tenPercentBankingComment, setTenPercentBankingComment] = useState("");
  const [claimBenefitComment, setClaimBenefitComment] = useState("");
  const [reviewComment, setReviewComment] = useState("");
  const [userRoles, setUserRoles] = useState<any>([]);
  const [fileName, setFileName] = useState<File | string>("No file chosen");
  const [serviceFileName, setServiceFileName] = useState<File | string>("No file chosen");
  const [exGratiaApprovalFile, setExGratiaApprovalFile] = useState<File | null>(null);
  const [showCloseClaimPopup, setShowCloseClaimPopup] = useState(false);
  const [closeReason, setCloseReason] = useState("");
  const [isGratiaApproved, setIsGratiaApproved] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);
  const [isAssignedMeOrSomeone, setIsAssignedMeOrSomeone] = useState(false);
  const [assignmentType, setAssignmentType] = useState<string>("");
  const [isFileChosen, setIsFileChosen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [deletedDocs, setDeletedDocs] = useState<string[]>([]);

  const [iceClaimNumber, setIceClaimNumber] = useState(
    claimData?.data?.iceClaimNumber
  );

  const [policyInfoData, setPolicyInfoData] = useState(
    claimData.data.policyResponseDto
  );

  const [detailOfDeceased, setDetailOfDeceased] = useState(
    claimData.data.deceasedResponseDto
  );
  const [claimantPersonalData, setClaimantPersonalData] = useState(
    claimData.data.claimantResponseDto
  );

  const [claimBenefitInfo, setClaimBenefitInfo] = useState(
    claimData.data.benefitSelections
  );
  const [benefitScheduleOverride, setBenefitScheduleOverride] = useState(
    claimData.data.benefit_schedule_override
  );

  //for ten percent
  const [personalData, setPersonalData] = useState(
    claimData.data.claimantResponseDto
  );
  const [bankingInfoData, setBankingInfoData] = useState(
    claimData.data.bankingInfoResponseDto
  );
  //.added new
  const [showClaimApprove, setShowClaimApprove] = useState(false);
  const [showRejectDialogue, setShowRejectDialogue] = useState(false);
  const [underwriterSubmitStatus, setUnderwriterSubmitStatus] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [reason, setReason] = useState("");
  const [status, setStatus] = useState("");
  const [claimSubmitResponse, setClaimSubmitResponse] = useState(false);
  const [selectedBenefitType, setSelectedBenefitType] = useState<string>("");

  const showVerified = useVerifiedStore((state) => state.showVerified);
  const setShowVerified = useVerifiedStore((state) => state.setShowVerified);
  const showRejected = useVerifiedStore((state) => state.showRejected);
  const setShowRejected = useVerifiedStore((state) => state.setShowRejected);
  const role = useUserStore((state) => state.role);
  const isChecked = useVerifyCheckboxStore((state) => state.isVerified);
  const setIsChecked = useVerifyCheckboxStore((state) => state.setIsVerified);
  const { isClaimAssigned, setIsClaimAssigned } = useAssignedClaimStore();
  const { documents } = useClaimFormStore.getState();
  const assignmentDetailsFromStore = useClaimDetailsStore((state) => state.assignmentDetails);


  const underwriterDocTypes = [
    "ASSESSMENT_DOCUMENT",
    "VERIFICATION_DOCUMENT",
    "FRAUD_DOCUMENTATION",
    "CLAIMS_REPORT",
    "OTHER_DOCUMENT",
  ];

  const underwriterDocuments = claimData.data.documentResponseDtoList.filter(
    (doc: any) => underwriterDocTypes.includes(doc.document_type)
  );
  const anyUnderwriterDocs =
    Object.values(documents).some((file) => file && file.name) ||
    underwriterDocuments.length > 0;

  const isEditableLocal = role === "consultant";

  const { userId, user_name } = useAuthStore();
  const claimType = useClaimTypeStore((state) => state.claimType);

  const isDeathClaim = claimType === "DEATH";

  const isBankingVerified =
    claimDetails?.data?.bankingInfoResponseDto?.is_verified;

  const { showInfoToast, showSuccessToast } = useToast();

  const isClosable = claimData.data.is_closable;

  const tabData = isDeathClaim
    ? [
        {
          id: 0,
          icon: {
            active: activePolicy,
            inactive: inactivePolicy,
          },
          alt: "Policy Information",
        },
        {
          id: 1,
          icon: {
            active: activeClaim,
            inactive: inactiveClaim,
          },
          alt: "Claimant Personal Information",
        },
        {
          id: 2,
          icon: {
            active: activeDetails,
            inactive: inactiveDetails,
          },
          alt: "Details of Deceased",
        },
        {
          id: 3,
          icon: {
            active: activeBanking,
            inactive: inactiveBanking,
          },
          alt: "Banking Information",
        },
        {
          id: 4,
          icon: {
            active: activeClaimInfo,
            inactive: inactiveClaimInfo,
          },
          alt: "Claims Benefit Schedule",
        },
        ...(reassigned || role === "underwriter" ||
        role === "finance" ||
        isFilterClicked ||
        isClaimSearched 
          ? [
              {
                id: 5,
                icon: {
                  active: activeReview,
                  inactive: inactiveReview,
                },
                alt: "Underwriting review",
              },
            ]
          : []),
      ]
    : [
        {
          id: 0,
          icon: {
            active: activePolicy,
            inactive: inactivePolicy,
          },
          alt: "Personal Information",
        },
        {
          id: 1,
          icon: {
            active: activeDocument,
            inactive: inactiveDocument,
          },
          alt: "Document Verification",
        },
        {
          id: 2,
          icon: {
            active: activeBanking,
            inactive: inactiveBanking,
          },
          alt: "Banking Information",
        },
        {
          id: 3,
          icon: {
            active: activeClaimInfo,
            inactive: inactiveClaimInfo,
          },
          alt: "Claim Schedule",
        },
      ];

  const renderTitle = () => {
    if (isDeathClaim) {
      switch (activeTab) {
        case 0:
          return "Policy Information";
        case 1:
          return "Claimant Personal Information";
        case 2:
          return "Details Of Deceased";
        case 3:
          return "Banking Information";
        case 4:
          return "Claims Benefit Schedule";
        case 5:
          return "Underwriting Review";
        default:
          return null;
      }
    } else {
      switch (activeTab) {
        case 0:
          return "Personal Information";
        case 1:
          return "Document Verification";
        case 2:
          return "Banking Information";
        case 3:
          return "Claim Schedule";
        default:
          return null;
      }
    }
  };

  const DROPDOWN_OPTIONS = {
    unAssigned: ["Assign Me", "Assign Someone"],
    single: ["Reassign Someone", "Unassign"],
    takeover: ["Reassign to me", "Reassign Someone", "Unassign"],
    withBackToConsultant: ["Reassign Someone", "Unassign", "Back to consultant"],
    withBackToAdmin: ["Reassign Someone", "Unassign", "Back to admin"],
    withBackToManager: ["Reassign Someone", "Unassign", "Back to manager"],
  };

  const isActuallyAssigned =
    claimData.data.assignedToUserId === userId ||
    assignmentDetailsFromStore?.toLowerCase() === user_name.toLowerCase();

  const isAssigned = isActuallyAssigned || isAssignedMeOrSomeone;
  const isAdmin = role === "claim_administrator";
  const isManager = role === "claim_manager";
  const isUnderwriter = role === "underwriter";
  const isUnassigned = assignmentDetails === "Unassigned";
  const isAssignedToMe = isAssigned;
  const isCurrentRoleQueue = isStatusInRoleQueue(role, claimStatus);

  let dropdownOptions;
  if (isUnassigned) {
    dropdownOptions = DROPDOWN_OPTIONS.unAssigned;
  } else if (!isAssignedToMe) {
    dropdownOptions = DROPDOWN_OPTIONS.takeover;
  } else if (isAdmin) {
    dropdownOptions = isAssigned
      ? DROPDOWN_OPTIONS.withBackToConsultant
      : DROPDOWN_OPTIONS.unAssigned;
  }
  // added manager
  else if (isManager) {
    dropdownOptions = isAssigned
      ? DROPDOWN_OPTIONS.withBackToAdmin
      : DROPDOWN_OPTIONS.unAssigned;
  } else if (isUnderwriter) {
    dropdownOptions = claimStatus === "DECLINED"
      ? DROPDOWN_OPTIONS.withBackToManager
      : isAssigned
      ? DROPDOWN_OPTIONS.withBackToManager
      : DROPDOWN_OPTIONS.unAssigned;
  } else {
    dropdownOptions = isAssigned
      ? DROPDOWN_OPTIONS.single
      : DROPDOWN_OPTIONS.unAssigned;
  }

  const isPaid = claimStatus === "PAID";
  const isUnderwriterActionable = ["REVIEWED", "DECLINED", "REJECTED"].includes(claimStatus);
  const isLaterApproval = ["DECLINED", "REJECTED"].includes(claimStatus);
  const isConsultantOrAdminOrManager =
    role === "consultant" ||
    role === "claim_administrator" ||
    role === "claim_manager";
  const isFinance = role === "finance";
  const hasPendingTierTwoOverride =
    benefitScheduleOverride?.status === "PENDING_APPROVAL" &&
    benefitScheduleOverride?.risk_tier === "TIER_2";

  const showDropdown =
    (isConsultantOrAdminOrManager || isFinance || role === "underwriter") &&
    isCurrentRoleQueue &&
    (isUnassigned ||
      (!isFinance || (isFinance && !isPaid)));

  const showSubmit =
    isAssignedToMe && (isConsultantOrAdminOrManager || (isFinance && !isPaid));


  const onPolicyCommentChange = (e: any) => {
    setPolicyComment(e.target.value);
  };
  const onPersonalInfoCommentChange = (e: any) => {
    setPersonalInfoComment(e.target.value);
  };
  const onClaimantCommentChange = (e: any) => {
    setClaimantComment(e.target.value);
  };
  const onDocumentInfoCommentChange = (e: any) => {
    setDocumentComment(e.target.value);
  };
  const onDeceasedCommentChange = (e: any) => {
    setDeceasedComment(e.target.value);
  };
  const onBankingCommentChange = (e: any) => {
    setBankingComment(e.target.value);
  };
  const onTenPercentBankingCommentChange = (e: any) => {
    setTenPercentBankingComment(e.target.value);
  };
  const onClaimBenefitCommentChange = (e: any) => {
    setClaimBenefitComment(e.target.value);
  };
  const onReviewCommentChange = (e: any) => {
    setReviewComment(e.target.value);
  };

  const handleCheckboxChange = (event: any) => {
    setIsChecked(event.target.checked);
  };

  const callUserRoles = async () => {
    setIsLoading(true);
    const res = await getUserRoles(role?.toUpperCase(), userId);
    if (res.status === 200) {
      setUserRoles(res.data);
    } else {
      showInfoToast(res.data.message);
    }
    setIsLoading(false);
  };

  const onAssignmentHandle = async (selectedUserId?: string, assignmentReason?: string) => {
    const requiresSelectedTarget = [
      "Assign Someone",
      "Reassign Someone",
      "Back to consultant",
      "Back to admin",
      "Back to manager",
    ].includes(assignmentType);

    if (requiresSelectedTarget && !selectedUserId) {
      showInfoToast("The user to assign this claim to could not be found.");
      return;
    }

    setIsLoading(true);
    setShowAssignment(false);
    setIsAssigning(true);
    const isAssignmentChange = ["Reassign to me", "Reassign Someone", "Unassign"].includes(
      assignmentType,
    );
    if (isAssignmentChange) {
      if (!claimData.data.assignedToUserId) {
        showInfoToast("Claim assignment details are outdated. Refresh the claim and try again.");
        resetToClaimList();
        setIsLoading(false);
        setIsAssigning(false);
        return;
      }
      const res = await changeClaimAssignment({
        claim_id: claimData.data.claimId,
        requested_by_user_id: userId,
        expected_assigned_to_user_id: claimData.data.assignedToUserId,
        new_assigned_to_user_id:
          assignmentType === "Unassign" ? null : selectedUserId || userId,
        reason: assignmentReason?.trim(),
      });
      if (res?.status === 200) {
        setPopupLabel(assignmentType === "Unassign" ? "Claim Unassigned" : "Claim Reassigned");
        setShowVerified(true);
      } else {
        showInfoToast(res?.data?.message || "Failed to change the claim assignment.");
        if (res?.status === 409) resetToClaimList();
      }
      setIsLoading(false);
      setIsAssigning(false);
      return;
    }
    const userIdToSend = selectedUserId || userId;
    const payload = {
      claim_id: claimData.data.claimId,
      assigned_to_user_id: userIdToSend,
      assigned_by_user_id: userId,
      claimant_personal_information: {
        comments: isDeathClaim ? claimantComment : personalInfoComment,
      },
      claims_benefit_schedule: {
        comments: claimBenefitComment,
      },
      banking_information: {
        comments: isDeathClaim ? bankingComment : tenPercentBankingComment,
      },
      document_verification: {
        comments: documentComment,
      },
      policy_information: {
        comments: policyComment,
      },

      details_of_deceased: {
        comments: deceasedComment,
      },
      underwriter_review: {
        comments: assignmentReason?.trim() || reviewComment,
      },
    };

    const res = await assignMe(payload);
    if (res.status === 200) {
       useClaimDetailsStore.getState().setAssignmentDetails(user_name);
      setPopupLabel("Assigned");
      setShowVerified(true);
      setShowSubmitButton(true);
      setIsAssignedMeOrSomeone(true);
      setIsClaimAssigned(true);
    } else {
      showInfoToast(res?.data?.message || "Failed to assign the claim.");
      if (res?.status === 409) {
        resetToClaimList();
      }
    }
    setIsLoading(false);
  };

  const handleDropdownChange = (e: any) => {
    const selected = e.target.value;
    setValue(e.target.value);
    setAssignmentType(selected);
    if (selected === "Assign Me") {
      setShowAssignment(true);
    }
    if (selected === "Assign Someone") {
      callUserRoles();
      setShowAssignment(true);
    }
    if (selected === "Reassign Someone") {
      callUserRoles();
      setShowAssignment(true);
    }
    if (selected === "Reassign to me" || selected === "Unassign") {
      setShowAssignment(true);
    }
    if (selected === "Back to consultant") {
      setShowAssignment(true);
    }
    if (selected === "Back to admin") {
      setShowAssignment(true);
    }
    if (selected === "Back to manager") {
      setShowAssignment(true);
    }
  };

  const handleCloseAssignmentPopup = () => {
    setShowAssignment(false);
    setValue("");
  };

  const getFinanceFile = (value: any) => {
    setFileName(value);
  };

  const getServiceFile = (value: any) => {
    setServiceFileName(value);
  };
  const getGratiaFile = (value: any) => {
    setExGratiaApprovalFile(value || null);
  };
  const handleGratiaCheck = (value: boolean) => {
    setIsGratiaApproved(value);
    if (!value) {
      setExGratiaApprovalFile(null);
    }
  };
  const getFiles = (value: any) => {
    setFile(value);
  };

  const getReason = (value: any) => {
    setReason(value);
  };

  const onHandleSumbit = async (
    label:
      | "Reviewed"
      | "Approved"
      | "Declined"
      | "Paid"
      | "admin_submit"
      | "consultant_submit"
  ) => {
    if (role === "claim_manager" && label === "Approved" && hasPendingTierTwoOverride) {
      setShowManagerSubmitPopup(false);
      showInfoToast("Second Claim Manager approval is required before approving this claim.");
      return;
    }

    setShowManagerSubmitPopup(false);
    setIsLoading(true);

    let claim_status = "";
    let status_reason = "";

    if (claimType === "DEATH") {
      claim_status =
        label === "Reviewed"
          ? "REVIEWED"
          : label === "Approved"
          ? "APPROVED"
          : label === "Declined"
          ? "REVIEWED"
          : label === "Paid"
          ? "PAID"
          : label === "admin_submit"
          ? "NEW"
          : "VETTED";

      status_reason =
        label === "Reviewed"
          ? "APPROVED"
          : label === "Declined"
          ? "DECLINED"
          : "";
    } else if (claimType === "TEN_PERCENT") {
      claim_status =
        label === "Reviewed"
          ? "APPROVED"
          : label === "Declined"
          ? "DECLINED"
          : label === "Paid"
          ? "PAID"
          : label === "admin_submit"
          ? "NEW"
          : label === "Approved"
          ? "APPROVED"
          : "VETTED";

      status_reason = "";
    }

    const payload = {
      claim_id: claimData.data.claimId,
      user_id: userId,
      claim_status,
      status_reason,
      is_ex_gratia_approved: isGratiaApproved,
      is_verified: isChecked,
      policy_information: { comments: policyComment },
      claimant_personal_information: {
        comments: isDeathClaim ? claimantComment : personalInfoComment,
      },
      details_of_deceased: { comments: deceasedComment },
      banking_information: {
        comments: isDeathClaim ? bankingComment : tenPercentBankingComment,
        is_verified: isBankingVerified,
      },
      document_verification: {
        comments: isDeathClaim ? "" : documentComment,
      },
      claims_benefit_schedule: { comments: claimBenefitComment },
    };

    const claimDocumentsDto: Record<string, string> = {
      assessmentDocument: documents["assessment_document"]?.name || "",
      verificationDocument: documents["verification_document"]?.name || "",
      fraudDocumentation: documents["fraud_documentation"]?.name || "",
      claimsReport: documents["claims_report"]?.name || "",
      otherDocument: documents["other_document"]?.name || "",
    };

    const formData = new FormData();
    const claimBlob = new Blob([JSON.stringify(payload)], {
      type: "application/json",
    });
    formData.append("claim", claimBlob);
    if (fileName instanceof File) {
      formData.append("cash_receipt", fileName);
    }
    if (serviceFileName instanceof File) {
      formData.append("service_receipt", serviceFileName);
    }
    if (isGratiaApproved && exGratiaApprovalFile instanceof File) {
      formData.append("ex_gratia_approval", exGratiaApprovalFile);
    }
    formData.append(
      "claimDocumentsDto",
      new Blob([JSON.stringify(claimDocumentsDto)], {
        type: "application/json",
      })
    );

    try {
      const res = await claimSubmit(formData);
      if (res.status === 200) {
        if (label === "Declined") {
          setPopupLabel("Declined");
          setShowRejected(true);
        } else if (label === "Paid") {
          setPopupLabel("Paid");
          setShowVerified(true);
        } else {
          setPopupLabel("Claim Submitted");
          setShowVerified(true);
        }
      } else {
        showInfoToast(res?.data?.message || "Failed to submit the claim.");
        if (res?.status === 409) {
          resetToClaimList();
        }
      }
    } catch (err) {
      showInfoToast("Something went wrong");
    }

    setIsLoading(false);
  };

  const handleSubmission = async (label: string) => {
    const { documents } = useClaimFormStore.getState();
    const formData = new FormData();
    setShowClaimApprove(false);
    setIsLoading(true);
    const payload = {
      claim_id: claimData.data.claimId,
      user_id: userId,
      claim_status: label === "Approved" ? "APPROVED" : "DECLINED",
      status_reason: label === "Decline" ? reason : "",
      policy_information: {
        comments: policyComment,
      },
      claimant_personal_information: {
        comments: claimantComment,
      },
      details_of_deceased: {
        comments: deceasedComment,
      },
      banking_information: {
        comments: bankingComment,
      },
      claims_benefit_schedule: {
        comments: claimBenefitComment,
      },
      underwriter_review: { comments: reviewComment },
    };

    const uploadedAssesmentDoc = documents["assessment_document"];
    const uploadedVerificationDoc = documents["verification_document"];
    const uploadedFraudDoc = documents["fraud_documentation"];
    const uploadedClaimsReport = documents["claims_report"];
    const uploadedOtherDoc = documents["other_document"];

    if (uploadedAssesmentDoc) {
      formData.append("assessment_document", uploadedAssesmentDoc);
    }
    if (uploadedVerificationDoc) {
      formData.append("verification_document", uploadedVerificationDoc);
    }
    if (uploadedFraudDoc) {
      formData.append("fraud_documentation", uploadedFraudDoc);
    }
    if (uploadedClaimsReport) {
      formData.append("claims_report", uploadedClaimsReport);
    }
    if (uploadedOtherDoc) {
      formData.append("other_document", uploadedOtherDoc);
    }

    const payloadBlob = new Blob([JSON.stringify(payload)], {
      type: "application/json",
    });

    formData.append("claim", payloadBlob);

    if (file) {
      formData.append("file", file);
    }

    const res = await claimSubmit(formData);
    if (res?.status === 200) {
      setStatus(res.data.status);
      setClaimSubmitResponse(true);
      if (label === "Approved") {
        setPopupLabel("Approved");
        setShowVerified(true);
      } else if (label === "Decline") {
        setPopupLabel("Declined");
        setShowRejected(true);
      }
    } else {
      showInfoToast(res?.data?.message || "Failed to submit the claim.");
      if (res?.status === 409) {
        resetToClaimList();
      }
    }
    setIsLoading(false);
  };
  const handleReasonChange = (value: any) => {
    setCloseReason(value);
  };

  const handleCloseClaim = async () => {
    setIsLoading(true);
    const payload = {
      claim_id: claimData.data.claimId,
      user_id: userId,
      claim_status: "CLOSED",
      status_reason: closeReason,
    };
    const res = await closeClaim(payload);
    if (res.status === 200) {
      setPopupLabel("Claim Closed");
      setShowVerified(true);
      setCloseReason("");
    }
    setIsLoading(false);
  };

  const handleUnderwriterDocsUpload = async () => {
    const { documents } = useClaimFormStore.getState();
    const formData = new FormData();

    const uploadedTypes = new Set<string>();

    Object.entries(documents).forEach(([key, file]) => {
      if (file) {
        formData.append(key, file);
        uploadedTypes.add(key.toUpperCase());
      }
    });

    const effectiveDeletedDocs = deletedDocs.filter((doc: any) => {
      const docType = doc.document_type || doc.type || "";
      return !uploadedTypes.has(docType.toUpperCase());
    });

    const deletedQuery = effectiveDeletedDocs
      .map((id) => `deletedDocumentId=${id}`)
      .join("&");

    const res = await uploadDocs(
      claimData.data.claimId,
      formData,
      deletedQuery
    );
    if (res.status === 200) {
      toast.success(res.data.message);
      setIsFileChosen(false);
      setEditMode(false);
      setDeletedDocs([])
      useClaimFormStore.getState().clearDocuments()
    } else showInfoToast(res.data.message);
  };

  useEffect(() => {
    if (isClaimAssigned) {
      setShowSubmitButton(true);
    }
  }, [isClaimAssigned]);

  useEffect(() => {
    if (claimData) {
      console.log("Loaded claim:", claimData);
    }
  }, [claimData]);

  useEffect(() => {
    if (showVerified || showRejected) {
      const timer = setTimeout(() => {
        // reset when rejected OR when assignmentType is not "Assign Me"
        if (showRejected || assignmentType !== "Assign Me") {
          resetToClaimList();
        }

        setShowVerified(false);
        setShowRejected(false);
        setIsAssigning(false);
        setAssignmentType("");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showVerified, showRejected, assignmentType]);

  useEffect(() => {
    if (!isDocsInitialized && claimData?.data?.documentResponseDtoList) {
      const list = claimData.data.documentResponseDtoList
        .filter((doc: any) => doc.document_type !== "BANK_PROOF")
        .map(({ document_type, file_name, file_url }: any) => ({
          label: document_type,
          name: file_name,
          link: file_url,
        }))
        .filter(Boolean);

      setFormattedDocuments(list);
      setIsDocsInitialized(true);
    }
  }, [claimData?.data?.documentResponseDtoList, isDocsInitialized]);

  useEffect(() => {
  if (claimBenefitData?.benefitSelections) {
    setClaimBenefitInfo(claimBenefitData.benefitSelections);
  }
}, [claimBenefitData]);

useEffect(() => {
  if (claimBenefitData?.claimBenefitInfo) {
    setClaimBenefitInfo(claimBenefitData.claimBenefitInfo);
  }
}, [claimBenefitData]);

  const refreshClaimBenefitSchedule = async () => {
    const res = await getClaimDetails(claimData.data.claimId, role);
    if (res?.status === 200) {
      const benefitSelections =
        res.data?.benefitSelections ||
        res.data?.benefit_selections ||
        res.data?.claimBenefitInfo ||
        res.data?.claim_benefit_info;
      if (benefitSelections) {
        setClaimBenefitInfo(benefitSelections);
      }
      setBenefitScheduleOverride(
        res.data?.benefit_schedule_override || res.data?.benefitScheduleOverride || null,
      );
    }
  };

  const renderTabContent = () => {
    const documents = claimData.data.documentResponseDtoList.reduce(
      (acc: Record<string, any[]>, doc: any) => {
        if (!acc[doc.document_type]) acc[doc.document_type] = [];
        acc[doc.document_type].push(doc);
        return acc;
      },
      {}
    );

    type TenPercentDocumentKeys =
      | "identity_document"
      | "selfie_with_identity"
      | "liveness_check"
      | "home_affairs_verification"
      | "bank_proof";

    const documentTypeKeyMap: Record<string, TenPercentDocumentKeys> = {
      IDENTITY_DOCUMENT: "identity_document",
      SELFIE_WITH_ID: "selfie_with_identity",
      LIVENESS_CHECK: "liveness_check",
      HOME_AFFAIRS_VERIFICATION: "home_affairs_verification",
    };

    const documentMap = claimData.data.documentResponseDtoList
      .filter((doc: any) => doc.document_type !== "BANK_PROOF")
      .reduce((acc: Record<string, any>, doc: any) => {
        acc[doc.document_type] = doc;
        return acc;
      }, {});

    const requiredDocuments = [
      { type: "IDENTITY_DOCUMENT", label: "Identity Document" },
      { type: "SELFIE_WITH_ID", label: "Selfie with Identity Document" },
      { type: "LIVENESS_CHECK", label: "Liveness Check" },
      { type: "HOME_AFFAIRS_VERIFICATION", label: "Verifying Images" },
    ];

    const formattedDocuments = requiredDocuments
      .map(({ type, label }) => {
        const matchedDoc = documentMap[type];
        const zustandKey = documentTypeKeyMap[type];
        return matchedDoc && zustandKey
          ? {
              key: zustandKey,
              label,
              name: matchedDoc.file_name,
              link: matchedDoc.file_url,
              documentId: matchedDoc.document_id,
            }
          : null;
      })
      .filter(Boolean);

    const handlePolicyFieldChange = (field: string, value: string) => {
      setPolicyInfoData((prev: any) => ({
        ...prev,
        [field]: value,
      }));

      setClaimDetails((prev: any) => ({
        ...prev,
        data: {
          ...prev.data,
          policyResponseDto: {
            ...prev.data.policyResponseDto,
            [field]: value,
          },
        },
      }));
    };
    const handleDeceasedFieldChange = (field: string, value: string) => {
      setDetailOfDeceased((prev: any) => ({
        ...prev,
        [field]: value,
      }));

      setClaimDetails((prev: any) => ({
        ...prev,
        data: {
          ...prev.data,
          deceasedResponseDto: {
            ...prev.data.deceasedResponseDto,
            [field]: value,
          },
        },
      }));
    };

    const handleClaimantFieldChange = (field: string, value: string) => {
      setClaimantPersonalData((prev: any) => ({
        ...prev,
        [field]: value,
      }));
      setClaimDetails((prev: any) => ({
        ...prev,
        data: {
          ...prev.data,
          claimantResponseDto: {
            ...prev.data.claimantResponseDto,
            [field]: value,
          },
        },
      }));
    };

    const handleBankingFieldChange = (field: string, value: string) => {
      console.log(field, value);
      setBankingInfoData((prev: any) => ({
        ...prev,
        [field]: value,
      }));
      setClaimDetails((prev: any) => ({
        ...prev,
        data: {
          ...prev.data,
          bankingInfoResponseDto: {
            ...prev.data.bankingInfoResponseDto,
            [field]: value,
          },
        },
      }));
    };

    const handleBenefitTypeChange = (type: string) => {
  setSelectedBenefitType(type);
};

    //for tenpercent

    const handlePersonalDataFieldChange = (field: string, value: string) => {
      setPersonalData((prev: any) => ({
        ...prev,
        [field]: value,
      }));
      setClaimDetails((prev: any) => ({
        ...prev,
        data: {
          ...prev.data,
          claimantResponseDto: {
            ...prev.data.claimantResponseDto,
            [field]: value,
          },
        },
      }));
    };

    const handleBankingInfoFieldChange = (field: string, value: string) => {
      setBankingInfoData((prev: any) => ({
        ...prev,
        [field]: value,
      }));
      setClaimDetails((prev: any) => ({
        ...prev,
        data: {
          ...prev.data,
          bankingInfoResponseDto: {
            ...prev.data.bankingInfoResponseDto,
            [field]: value,
          },
        },
      }));
    };

    const deceasedDocTypes = [
      "DECEASED_ID",
      "POLICE_ACCIDENTAL_REPORT",
      "MEDICAL_REPORT",
      "DEATH_CERTIFICATE",
      "OTHER_DOCUMENT",
      "DHA_1663_FORM",
      "DHA_1680_HOME_DEATH_FORM",
      "DECEASED_YOUNG_ADULT",
    ];

    const underwriterDocTypes = [
      "ASSESSMENT_DOCUMENT",
      "VERIFICATION_DOCUMENT",
      "FRAUD_DOCUMENTATION",
      "CLAIMS_REPORT",
      "OTHER_DOCUMENT",
    ];

    const bankDoctypes = ["BANK_STATEMENT", "SIGNATURE_OF_CLAIMANT"];

    const deceasedDocuments = claimData.data.documentResponseDtoList.filter(
      (doc: any) => deceasedDocTypes.includes(doc.document_type)
    );

    const underwriterDocuments = claimData.data.documentResponseDtoList.filter(
      (doc: any) => underwriterDocTypes.includes(doc.document_type)
    );

    const bankDocuments = claimData.data.documentResponseDtoList.filter(
      (doc: any) => bankDoctypes.includes(doc.document_type)
    );

    if (isDeathClaim) {
      switch (activeTab) {
        case 0:
          return (
            <PolicyInfoForm
              policyInfoData={policyInfoData}
              iceClaimNumber={iceClaimNumber}
              commentData={claimData.data.commentResponseDtoList}
              documentData={documents.POLICY || []}
              onPolicyCommentChange={onPolicyCommentChange}
              isAssigned={isAssigned}
              claimStatus={claimStatus}
              policyComment={policyComment}
              isEditable={isEditable}
              handlePolicyFieldChange={handlePolicyFieldChange}
              handleFileUpload={handleFileUpload}
            />
          );
        case 1:
          return (
            <ClaimantPersonalInfoForm
              claimantPersonalData={claimantPersonalData}
              iceClaimNumber={iceClaimNumber}
              commentData={claimData.data.commentResponseDtoList}
              onClaimantCommentChange={onClaimantCommentChange}
              documentData={documents.CLAIMANT_ID || []}
              isAssigned={isAssigned}
              claimStatus={claimStatus}
              claimantComment={claimantComment}
              isEditable={isEditable}
              handleClaimantFieldChange={handleClaimantFieldChange}
              handleFileUpload={handleFileUpload}
            />
          );
        case 2:
          return (
            <DetailsOfDeceasedForm
              detailOfDeceased={detailOfDeceased}
              iceClaimNumber={iceClaimNumber}
              commentData={claimData.data.commentResponseDtoList}
              onDeceasedCommentChange={onDeceasedCommentChange}
              documentData={deceasedDocuments}
              assignedTo={claimData.data.assignedTo}
              isAssigned={isAssigned}
              claimStatus={claimStatus}
              deceasedComment={deceasedComment}
              isEditable={isEditable}
              handleDeceasedFieldChange={handleDeceasedFieldChange}
              handleFileUpload={handleFileUpload}
            />
          );
        case 3:
          return (
            <BankingInfoForm
              bankingInfo={bankingInfoData}
              iceClaimNumber={iceClaimNumber}
              commentData={claimData.data.commentResponseDtoList}
              onBankingCommentChange={onBankingCommentChange}
              documentData={bankDocuments}
              assignedTo={claimData.data.assignedTo}
              isAssigned={isAssigned}
              claimStatus={claimStatus}
              bankingComment={bankingComment}
              isEditable={isEditable}
              handleBankingFieldChange={handleBankingFieldChange}
              handleFileUpload={handleFileUpload}
            />
          );
        case 4:
          return (
            <ClaimsBenefitScheduleForm
              claimBenefitInfo={claimBenefitInfo}
              iceClaimNumber={iceClaimNumber}
              onClaimBenefitCommentChange={onClaimBenefitCommentChange}
              commentData={claimData.data.commentResponseDtoList}
              documentData={documents.BENEFIT_SCHEDULE || []}
              exGratiaFile={documents.EX_GRATIA_APPROVAL || []}
              cashReciept={documents.CASH_RECEIPT || []}
              serviceReciept={documents.SERVICE_RECEIPT || []}
              repudiationFile={documents.REPUDIATION_LETTER || []}
              statusReason={claimData.data.declinedReason}
              assignedTo={claimData.data.assignedTo}
              isAssigned={isAssigned}
              claimStatus={claimStatus}
              isEditable={isEditable}
              claimBenefitComment={claimBenefitComment}
              claimBenefitData={claimBenefitData}
             onBenefitTypeChange={onBenefitTypeChange}
             isOrangeCampaign={isOrangeCampaign}
             isOrangeCampaignServicesOnly={claimData.data?.is_orange_campaign_services_only}
             orangeCampaignReference={claimData.data?.orange_campaign_reference}
             claimId={claimData.data.claimId}
             userId={userId}
             role={role}
             benefitScheduleOverride={benefitScheduleOverride}
             submitBenefitOverride={submitBenefitOverride}
             approveBenefitOverride={approveBenefitOverride}
             rejectBenefitOverride={rejectBenefitOverride}
             getBenefitOverrideHistory={getBenefitOverrideHistory}
             getBenefitInceptionContext={getBenefitInceptionContext}
             onBenefitOverrideSaved={refreshClaimBenefitSchedule}
             showInfoToast={showInfoToast}
             showSuccessToast={showSuccessToast}
            />
          );
        case 5:
          return (
            <UnderwirterReview
              isAssigned={isAssigned}
              commentData={claimData.data.commentResponseDtoList}
              claimStatus={claimStatus}
              isEditable={isEditable}
              onReviewCommentChange={onReviewCommentChange}
              reviewComment={reviewComment}
              documentData={underwriterDocuments}
              onFileChosen={setIsFileChosen}
              isFilterClicked={isFilterClicked}
              editMode={editMode}
              iceClaimNumber={iceClaimNumber}
              setDeletedDocs={setDeletedDocs}
            />
          );
        default:
          return null;
      }
    } else {
      switch (activeTab) {
        case 0:
          return (
            <PersonalInformationForm
              personalData={personalData}
              policyData={claimData.data.policyResponseDto}
              onPersonalInfoCommentChange={onPersonalInfoCommentChange}
              isAssigned={isAssigned}
              claimStatus={claimStatus}
              personalInfoComment={personalInfoComment}
              commentData={claimData.data.commentResponseDtoList}
              isEditable={isEditable}
              handlePersonalDataFieldChange={handlePersonalDataFieldChange}
              role={userRoles}
            />
          );
        case 1:
          return (
            <DocumentVerificationForm
              documentData={formattedDocuments}
              iceClaimNumber={iceClaimNumber}
              onDocumentInfoCommentChange={onDocumentInfoCommentChange}
              isAssigned={isAssigned}
              claimStatus={claimStatus}
              documentComment={documentComment}
              commentData={claimData.data.commentResponseDtoList}
              isEditable={isEditable}
              onDocumentDeleteChange={setFormattedDocuments}
              handleFileUpload={handleFileUpload}
              onDocumentFileChange={onDocumentFileChange}
            />
          );

        case 2:
          return (
            <BankingForm
              bankingInfoData={bankingInfoData}
              iceClaimNumber={iceClaimNumber}
              commentData={claimData.data.commentResponseDtoList}
              onTenPercentBankingCommentChange={
                onTenPercentBankingCommentChange
              }
              documentData={documents.BANK_PROOF || []}
              assignedTo={claimData.data.assignedTo}
              isAssigned={isAssigned}
              claimStatus={claimStatus}
              tenPercentBankingComment={tenPercentBankingComment}
              isEditable={isEditable}
              handleBankingInfoFieldChange={handleBankingInfoFieldChange}
              policyNumber={claimData.data.policyNumber}
            />
          );
        case 3:
          return (
            <ClaimsScheduleForm
              documentData={documents.EX_GRATIA_APPROVAL || []}
              iceClaimNumber={iceClaimNumber}
              receiptFile={documents.CASH_RECEIPT || []}
              claimBenfitSchedule={claimData.data}
              isVerifiedValue={isBankingVerified}
              isEditable={isEditableLocal}
              role={role}
              handleCheckboxChange={handleCheckboxChange}
              isVerified={isBankingVerified}
              isChecked={isChecked}
              legacyVerified={claimDetails.data.isVerified}
              isAssigned={isAssigned}
              
            />
          );
        default:
          return null;
      }
    }
  };

  return (
    <Box p={3} bgcolor="background.paper">
      {/* Top Controls */}
      {isLoading ? <Loader isLoading={isLoading} /> : null}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexDirection={{ xs: "column", sm: "row" }}
        mb={3}
      >
        <Typography fontSize={24} fontWeight={600}>
          <span
            style={{ color: "#EC6E00", cursor: "pointer" }}
            onClick={resetToClaimList}
          >
            {isDeathClaim ? "Death Claim/" : "10% Claim/"}
          </span>
          <span>{claimData.data.policyResponseDto.policy_number}/</span>
          {renderTitle()}
        </Typography>

        <Box
          display="flex"
          gap={1.5}
          flexWrap="wrap"
          justifyContent={{ xs: "flex-start", sm: "flex-end" }}
          alignItems="center"
        >
          {showDropdown &&
            ((role === "consultant" && claimStatus === "DRAFT") ||
              (role === "claim_administrator" && claimStatus === "VETTED") ||
              (role === "claim_manager" && claimStatus === "NEW") ||
              (role === "finance" && claimStatus === "APPROVED") ||
              (role === "underwriter" && ["REVIEWED", "DECLINED"].includes(claimStatus))) && (
              <CustomDropdown
                value={value}
                onChange={handleDropdownChange}
                options={dropdownOptions}
                placeholder="Select Option"
              />
            )}
          {((role === "consultant" && claimStatus === "DRAFT") ||
            (role === "claim_administrator" && claimStatus === "VETTED") ||
            (role === "claim_manager" && claimStatus === "NEW") ||
            (role === "underwriter" && claimStatus === "REVIEWED")) &&
            isClosable && (
              <ButtonComp
                variant="contained"
                height={40}
                width={150}
                textTransform="none"
                color="secondary"
                onClick={() => setShowCloseClaimPopup(true)}
              >
                Close Claim
              </ButtonComp>
            )}

          {role === "underwriter" && isAssignedToMe && isUnderwriterActionable && (
            <>
              <ButtonUnderwriter
                onClick={() => setShowClaimApprove(true)}
                icon={checkIcon}
                label={isLaterApproval ? "Approve & Resume" : "Approve"}
                color="#20BF55"
                width={isLaterApproval ? 210 : 150}
                fontSize="15px"
              />
              {!isLaterApproval && (
                <ButtonUnderwriter
                  onClick={() => setShowRejectDialogue(true)}
                  icon={rejectIcon}
                  label="Decline"
                  color="#E8003F"
                  width={150}
                  fontSize="15px"
                />
              )}
            </>
          )}

          {isMobile ? (
            <Tooltip title="History">
              <ButtonComp
                variant="contained"
                height={40}
                width={40}
                color="secondary"
                onClick={onHistoryClick}
              >
                <HistoryIcon />
              </ButtonComp>
            </Tooltip>
          ) : (
            <ButtonComp
              variant="contained"
              height={40}
              width={120}
              textTransform="none"
              color="secondary"
              onClick={onHistoryClick}
            >
              History
            </ButtonComp>
          )}

          {role !== "underwriter" &&
            claimStatus !== "CLOSED" &&
            (showSubmitButton || showSubmit) && (
              <ButtonComp
                variant="outlined"
                height={40}
                width={190}
                textTransform="none"
                disabled={role === "claim_manager" && hasPendingTierTwoOverride}
                onClick={() => {
                  if (isEditable && role === "consultant") {
                    handleUpdate?.();
                  } else {
                    if (role === "claim_manager") {
                      if (hasPendingTierTwoOverride) {
                        showInfoToast(
                          "Second Claim Manager approval is required before approving this claim."
                        );
                        return;
                      }
                      if (isDeathClaim) {
                        setShowManagerSubmitPopup(true);
                      } else if (isChecked) {
                        setShowManagerSubmitPopup(true);
                      } else
                        showInfoToast("Please verify details in legacy system");
                    } else if (role === "finance") {
                      setShowFinanceSubmitPopup(true);
                    } else if (role === "claim_administrator") {
                      onHandleSumbit("admin_submit");
                    } else if (role === "consultant") {
                      if (!isBankingVerified) {
                        showInfoToast("Please verify bank information");
                      } else onHandleSumbit("consultant_submit");
                    } else {
                      onHandleSumbit("consultant_submit");
                    }
                  }
                }}
              >
                {isEditable && role === "consultant" ? "Update" : "Submit"}
              </ButtonComp>
            )}

          {role === "consultant" &&
            claimStatus === "DRAFT" &&
            (assignmentDetails === user_name ||
              isAssignedMeOrSomeone ||
              showSubmitButton) && (
              <BorderColorIcon
                sx={{ cursor: "pointer", color: "black", fontSize: "2rem" }}
                onClick={onEditClick}
              />
            )}
        </Box>
      </Box>
      {role === "claim_manager" && hasPendingTierTwoOverride && (
        <Box
          sx={{
            mb: 2,
            px: 2,
            py: 1,
            border: "1px solid #FDBA74",
            borderLeft: "4px solid #C2410C",
            borderRadius: 1.5,
            backgroundColor: "#FFF7ED",
            color: "#7C2D12",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Claim approval is locked until another Claim Manager approves the pending Tier 2 benefit override.
        </Box>
      )}
      {/* Card Container */}
      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          background: "#ffffff",
        }}
        elevation={2}
      >
        {/* Icons Header */}
        <ClaimTabs
          tabs={tabData}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        {/* Section Title */}
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Typography
            fontSize={25}
            fontWeight={600}
            color="primary"
            textAlign="left"
            gutterBottom
            textTransform="uppercase"
          >
            {renderTitle()}
          </Typography>

          <Box display="flex" flexDirection="row" gap={3}>
            {isDeathClaim && activeTab === 5 && isFileChosen && (
              <ButtonComp
                variant="outlined"
                height={40}
                width={190}
                textTransform="none"
                onClick={handleUnderwriterDocsUpload}
              >
                Upload
              </ButtonComp>
            )}
            {isDeathClaim &&
              activeTab === 5 &&
              role === "underwriter" &&
              anyUnderwriterDocs && (
                <BorderColorIcon
                  sx={{ cursor: "pointer", color: "black", fontSize: "2rem" }}
                  onClick={() => setEditMode((prev) => !prev)}
                />
              )}
          </Box>
        </Box>
        {/* Input Grid */}
        {renderTabContent()}
      </Paper>

      {isDeathClaim && (role === "claim_administrator" || role === "claim_manager" || role === "underwriter") && (
        <SupportingDocumentsSection claimId={claimData?.data?.claimId} iceClaimNumber={iceClaimNumber} />
      )}

      <AssignmentPopup
        open={showAssignment}
        onClose={handleCloseAssignmentPopup}
        userRoles={
          value === "Reassign Someone"
            ? userRoles.filter((user: any) => user.userId !== claimData.data.assignedToUserId)
            : userRoles
        }
        selectedValue={value}
        onAssignmentHandle={onAssignmentHandle}
        claimData={claimData}
        requireReason={
          ["Reassign to me", "Reassign Someone", "Unassign"].includes(value) ||
          (role === "underwriter" &&
            claimStatus === "DECLINED" &&
            value === "Back to manager")
        }
      />
      <VerifiedPopup
        label={popupLabel}
        open={showVerified}
        onClose={() => setShowVerified(false)}
      />
      <SubmitPopup
        open={showManagerSubmitPopup}
        onClose={() => setShowManagerSubmitPopup(false)}
        onSubmit={onHandleSumbit}
        getGratiaFile={getGratiaFile}
        fileName={fileName}
        handleGratiaCheck={handleGratiaCheck}
        isGratiaApproved={isGratiaApproved}
        claimBenefitInfo={claimBenefitInfo}
        isClaimSubmissionWindowExpired={isClaimSubmissionWindowExpired}
        deceasedResponseDto={claimData?.data?.deceasedResponseDto}
      />

      <FinanceSubmitPopup
        open={showFinanceSubmitPopup}
        onClose={() => setShowFinanceSubmitPopup(false)}
        bankingInfoData={claimData.data.bankingInfoResponseDto}
        onSubmit={onHandleSumbit}
        getFinanceFile={getFinanceFile}
        getServiceFile={getServiceFile}
        fileName={fileName}
        serviceFileName={serviceFileName}
        claimBenefitInfo={claimBenefitInfo}
      />
      <RejectedPopup
        label="Declined"
        open={showRejected}
        onClose={() => setShowRejected(false)}
        text="Mail Sent"
      />
      <CloseClaimPopup
        open={showCloseClaimPopup}
        onClose={() => setShowCloseClaimPopup(false)}
        onChange={handleReasonChange}
        handleCloseClaim={handleCloseClaim}
        closeReason={closeReason}
      />
      {/* ✅ Underwriter-only popups */}
      <ClaimApprovePopup
        open={showClaimApprove}
        onClose={() => setShowClaimApprove(false)}
        onApprove={() => handleSubmission("Approved")}
      />

      {underwriterSubmitStatus === "APPROVED" && (
        <ClaimSubmitResponse
          status={underwriterSubmitStatus}
          isLoading={isLoading}
        />
      )}

      {underwriterSubmitStatus === "DECLINED" && (
        <RejectedPopup
          label="Claim Rejected"
          open={true}
          onClose={() => setUnderwriterSubmitStatus("")}
          text="Claim has been rejected successfully. Mail sent."
        />
      )}
      <RejectDialogueBox
        label="Decline"
        open={showRejectDialogue}
        onClose={() => setShowRejectDialogue(false)}
        handleSubmission={handleSubmission}
        getFiles={getFiles}
        file={file}
        getReason={getReason}
        reason={reason}
      />
    </Box>
  );
};
export default PersonalInfo;
